export default __webpack_public_path__ + "static/media/Landing_Logo_GeneticaHumana.6d4afc43.png";